module.exports = __webpack_public_path__ + "img/banner_home.1d3da2e9.svg";